import { BaseTransDocument } from '@dato-proxy/entities/basetransdocument.entity';
import { BaseDocument } from '@dato-proxy/entities/basedocument.entity';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { Globals } from '../../_globals';
import { CompanyView } from '@dato-proxy/views/company.view';

class State extends BaseState {
    IsShowAdditionalNotes: boolean;
    IsActiveUser: boolean;
    IsAllowPayment: boolean;
    IsEnableMultiCompany: boolean;
}
@Component({
    selector: 'base-grid-document',
    template: '<div></div>'
})
export abstract class BaseGridDocumentComponent<TEntity extends BaseEntity> extends BaseGridComponent<TEntity, State> {

    @Input() IsShowAttachments: boolean;
    @Input() Companies: CompanyView[];
    @Input() QuickFilters: TemplateRef<any>;

    @Output() SelectionChanged: EventEmitter<BaseDocument[]> = new EventEmitter<BaseDocument[]>();
    @Output() PayByOne: EventEmitter<BaseDocument> = new EventEmitter<BaseDocument>();
    @Output() DocNumClick: EventEmitter<BaseDocument> = new EventEmitter<BaseDocument>();
    @Output() ShowFiles: EventEmitter<BaseDocument> = new EventEmitter<BaseDocument>();

    constructor(public override A: ServiceBagService, public override ComponentName: string, EntityType: (new () => TEntity)) {
        super(A, ComponentName, EntityType, State);
    }

    override OnInitComponent() {
        this.State.IsShowAdditionalNotes = Globals.SystemOption.IsShowAdditionalNotes;
        this.State.IsActiveUser = Globals.IsActiveUser;
        this.State.IsAllowPayment = Globals.SystemOption.IsAllowPayment;
        this.State.IsEnableMultiCompany = Globals.SystemOption.IsEnableMultiCompany;
    }

    OnPay(Document: BaseDocument) {
        this.ClearSelection();
        this.PayByOne.emit(Document);
    }

    IsDocNumDisabled = (cell) => {
        return !cell?.data || (!this.IsAllowedToViewUnsent(cell?.data?.TransType) && !cell?.data?.PdfUrl) ;
    }

    private IsAllowedToViewUnsent(transType: number): boolean {
        switch (transType) {
            case (13): case (14): {
                return Globals.SystemOption.IsAllowViewingUnsentInvoices;
            }
            case (15): case (16): {
                return Globals.SystemOption.IsAllowViewingUnsentDeliveries;
            }
            case (24): {
                return Globals.SystemOption.IsAllowViewingUnsentReceipt;
            }
            default: {return false }
        }
    }

    OnDocNumClick(cell: any) {
        const document = cell?.data as BaseDocument;
        if (!document) return;

        this.DocNumClick.emit(document);
    }

    OnSelectionChanged(e) {
        const documents = e.selectedRowsData as BaseDocument[];

        const documentsForClear = documents.filter(x => !x.PaymentSum || x.PaymentSum === 0 || (x as BaseTransDocument).IsPaymentAllowed == false);
        this.grid.instance.deselectRows(documentsForClear.map(x => x.EntryID));
        
        this.SelectionChanged.emit(documents);
    }

    OnCellPrepared(e) {
        if (e.column.command == 'select') {
            const document = e.data as BaseDocument;

            if (document && (!document.PaymentSum || document.PaymentSum == 0 || (document as BaseTransDocument).IsPaymentAllowed == false)) {
                (e.cellElement.children[0] as HTMLElement).style.visibility = 'hidden';
            }
        }
    }

    OnShowFiles(document: BaseDocument) {
        this.ShowFiles.emit(document);
    }

    ClearSelection() {
        this.grid.selectedRowKeys = [];
    }

    OnToolbarPreparing(e) {
        e.toolbarOptions.items.push({
            location: 'after',
            template: 'quickFilters',
            isCustom: true
        });
    }
}
